var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 135,
    viewBox: "0 0 138 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 0C30.8775 0 0 30.8948 0 69C0 99.4922 19.7685 125.35 47.1787 134.464C50.6287 135.113 51.8937 132.98 51.8937 131.146C51.8937 129.507 51.8363 125.166 51.8075 119.416C32.614 123.579 28.566 110.158 28.566 110.158C25.4265 102.195 20.8897 100.067 20.8897 100.067C14.6395 95.7892 21.3728 95.8755 21.3728 95.8755C28.3015 96.3585 31.9412 102.982 31.9412 102.982C38.0937 113.534 48.093 110.486 52.0375 108.721C52.6585 104.259 54.4353 101.217 56.4075 99.4922C41.0838 97.7672 24.978 91.8333 24.978 65.3948C24.978 57.8623 27.6518 51.7097 32.0792 46.8797C31.303 45.1375 28.9743 38.1225 32.683 28.6178C32.683 28.6178 38.4618 26.7663 51.658 35.6903C57.178 34.155 63.043 33.396 68.908 33.3615C74.773 33.396 80.638 34.155 86.158 35.6903C99.268 26.7663 105.047 28.6178 105.047 28.6178C108.755 38.1225 106.427 45.1375 105.737 46.8797C110.135 51.7097 112.809 57.8623 112.809 65.3948C112.809 91.9023 96.6805 97.7385 81.328 99.4347C83.743 101.505 85.9855 105.737 85.9855 112.2C85.9855 121.434 85.8993 128.852 85.8993 131.094C85.8993 132.905 87.1067 135.062 90.643 134.372C118.249 125.321 138 99.4463 138 69C138 30.8948 107.105 0 69 0",
    fill: "#ccdfff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.1d995eb7759857b9aefefc1bff3d3884.svg";
export { ForwardRef as ReactComponent };